import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';
import { ORDER } from '../../tokens/requestTypes';
import type { CustomerOrder } from '../../types/CustomerOrder';
import { getSubscriptionErrorMessage } from '../../types/SubscriptionResponse';
import type { IWebSocketClient } from '../WebSocketClient';

export function observeWLOrderByID(
  client: IWebSocketClient<CustomerOrder>,
  orderID: string
): Observable<CustomerOrder> {
  return new Observable(observer => {
    const address = uuid();
    client.registerSubscription(
      address,
      [{ name: ORDER, tag: 'useOrder_id_specific', OrderID: orderID }],
      (error, response) => {
        if (error) {
          observer.error(
            error instanceof Error
              ? error
              : new Error(getSubscriptionErrorMessage(error) ?? 'Unable to subscribe to order', { cause: error })
          );
          return;
        }
        for (const order of response?.data ?? []) {
          if (order.OrderID === orderID) {
            observer.next(order);
          }
        }
      }
    );
    return () => client.unregisterSubscription(address);
  });
}
